export class CuestionarioLegalCreateDto {
    constructor() {
        this.motivoSolicitud = null;
        this.fechaTratamiento = null;
        this.consistenciaTratamiento = null;
        this.avanceTratamiento = null;
        this.seguimientoDentalia = null;
        this.detalle = null;
    }
}
